import { useRelayInfo } from "../../hooks";
import { useSnackbar } from "notistack";
import RelayAPI from "../../../../../api/RelayAPI";
import { Button, TextInput, Typography } from "@monolith-forensics/monolith-ui";
import { useForm } from "@mantine/form";
import { SectionContainer } from "./SectionContainer";

export const TenantName: React.FC = () => {
  const { relayInfo, refetch } = useRelayInfo();

  const { enqueueSnackbar } = useSnackbar();

  const form = useForm({
    initialValues: {
      tenant_org: relayInfo?.tenant_org,
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.tenant_org) {
        errors.tenant_org = "This field is required";
        return errors;
      }

      const regex = /^[a-zA-Z0-9 ]+$/;

      if (!regex.test(values.tenant_org)) {
        errors.tenant_org = "Only letters, numbers, and spaces are allowed";
      }

      return errors;
    },
  });

  if (!relayInfo) return null;

  const handleUpdate = async () => {
    const validationResults = form.validate();

    if (validationResults.hasErrors) {
      return;
    }

    const { tenant_org } = form.getValues();

    await RelayAPI.updateTenantName({
      tenant_org,
      tenant_uuid: relayInfo.tenant_uuid,
    });

    enqueueSnackbar("Relay tenant name updated successfully", {
      variant: "success",
    });

    refetch();
    form.clearErrors();
    form.resetDirty();
  };
  return (
    <SectionContainer>
      <div>
        <Typography variant="h3" display="inline">
          Tenant Name
        </Typography>
        <div className="message">
          This is the name of your Relay tenant that will display in Relay.
        </div>
      </div>
      <TextInput
        label="Tenant Name"
        placeholder="Enter a new Relay tenant name"
        style={{ maxWidth: 400 }}
        key={form.key("tenant_org")}
        {...form.getInputProps("tenant_org")}
      />
      <Button
        variant="contained"
        color="primary"
        style={{ marginLeft: "auto" }}
        size="xs"
        disabled={!form.isDirty()}
        onClick={handleUpdate}
      >
        Update Name
      </Button>
    </SectionContainer>
  );
};
